exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-032eb4ca] {\n  text-decoration: none;\n}\n.list-box-status[data-v-032eb4ca] {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.list-box-header[data-v-032eb4ca] {\n  min-height: 66px;\n}\n.full-name[data-v-032eb4ca] {\n  font-weight: 500;\n  font-size: 16px;\n  color: #4c5669;\n}\n.active[data-v-032eb4ca] {\n  color: #2db400;\n  font-size: 11px;\n}\n.inactive[data-v-032eb4ca] {\n  color: #ff4d4d;\n  font-size: 11px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-032eb4ca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contracts/ContractsBlock.vue
// module id = ApFE
// module chunks = 0